export default __webpack_public_path__ + "static/media/NEDEN-OLMASIN-GIF-15.06.81b4e381.gif";